import React, { useState, useEffect, useMemo } from 'react';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import InputModal from '../InputModal';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  workNumModifyStateRecoil,
} from '../../atom/ModalAtom';
import { roomAPI } from '../../api/axiosIndex';
import { Icon } from '../../component/Icon';
import { refreshDataStateRecoil } from '../../atom/CommonAtom';
import { socketio } from '../../api/socket.api';
import { lineIdStateRecoil } from '../../atom/RoomAtom';
interface WorkNumModiFyProps {
  onListUpdate: () => void;
  isNoneDateSelect?: boolean;
}

const WorkNumModiFy = ({
  onListUpdate,
  isNoneDateSelect = false,
}: WorkNumModiFyProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const setModalState = useSetRecoilState(workNumModifyStateRecoil);

  const [selectDate, setSelectDate] = useState<string>('');
  const [workNumId, setWorkNumId] = useState<number>(0);
  const [workNum, setWorkNum] = useState<number>(0);
  const [modifyWorkNum, setModifyWorkNum] = useState<number | null>(null);
  const [workNumNone, setWorkNumNone] = useState<boolean>(false);

  // 방 상세에서 본인 탕수 수정할 때 lineId를 받아올 방법이 없어서 여기는 리코일로 사용
  const [lineIdState, setLineIdState] = useRecoilState(lineIdStateRecoil);

  const getDateWorkNums = async (date: string) => {
    try {
      const response = await roomAPI.getDateWorkNums(
        Number(date.split('-')[0]),
        Number(date.split('-')[1]),
        Number(date.split('-')[2]),
      );
      setWorkNumId(response.data[0].id);
      setWorkNum(response.data[0].cycle);
    } catch {
      setError('선택하신 날짜는 존재하지 않습니다.');
      setWorkNumNone(true);
      setWorkNum(0);
    }
  };

  const onChangeModifyDate = async (e: React.ChangeEvent<HTMLInputElement>) => {
    setWorkNumNone(false);
    setSelectDate(e.target.value);
    getDateWorkNums(e.target.value);
  };

  const handleConfirm = async () => {
    if (workNumNone) {
      setError('선택하신 날짜는 존재하지 않습니다.');
      return;
    }

    if (modifyWorkNum === null) {
      setError(blankMsg);
      return;
    }

    try {
      await roomAPI.putWorkNum(workNumId, modifyWorkNum);

      if (isNoneDateSelect) {
        socketio.entry(Number(lineIdState));
      }

      setModalState(false);
      onListUpdate();
      setConfirm('성공적으로 수정되었습니다.');
    } catch {
      setError('탕수 수정에 실패했습니다.');
    }
  };

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    setSelectDate(formattedDate);
    getDateWorkNums(formattedDate);
  }, []);

  return (
    <>
      <InputModal
        title="실 수정"
        onCancel={() => setModalState(false)}
        onConfirm={handleConfirm}
      >
        <ul className="input-wrap">
          {!isNoneDateSelect && (
            <li>
              <h2>수정 날짜</h2>
              <CS.TextInputType1
                type="date"
                value={selectDate}
                onChange={onChangeModifyDate}
              />
            </li>
          )}
          <li>
            <h2>현재 탕수</h2>
            <CS.TextInputType1
              placeholder="0"
              type="number"
              disabled={true}
              value={workNum}
              onChange={(e) => setWorkNum(e.target.valueAsNumber)}
            />
          </li>
          <li>
            <h2>
              수정 탕수
              <span className="img-box">
                <Icon name="StarIcon" size="100%" color="#FF5151" />
              </span>
            </h2>
            <CS.TextInputType1
              placeholder="수정 탕수 입력"
              type="text"
              value={
                modifyWorkNum !== null ? modifyWorkNum.toLocaleString() : ''
              }
              disabled={workNumNone}
              onChange={(e) => {
                const value = e.target.value
                  .replace(/[^0-9]/g, '')
                  .replace(/,/g, '');
                setModifyWorkNum(value === '' ? null : Number(value));
              }}
            />
          </li>
        </ul>
      </InputModal>
    </>
  );
};

export default WorkNumModiFy;
